import React from 'react'
import { Col, Wrapper } from 'src/ui/layout'
import { styled } from 'src/ui/theme'
import { Body, Header } from 'src/ui/typography'
import { CULTURE_DATA } from './constants'

const Title = styled.div`
  display: grid;

  grid-template-columns: 1fr 1fr;
  gap: 50px;

  box-sizing: border-box;
`

const CulturesBlock = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;
`

const CultureItem = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`

const IconBlock = styled.div`
  padding: 9px;
  background-color: #f1f1f8;
`

export type Props = {}

export const Culture = ({}: Props) => {
  return (
    <Wrapper>
      <Title>
        <Col>
          <Header size="h2" as="h2">
            Корпоративная культура единомышленников
          </Header>
        </Col>

        <Col>
          <CulturesBlock>
            {CULTURE_DATA.map((item) => (
              <CultureItem key={item.id}>
                <IconBlock>{item.icon}</IconBlock>
                <Header as="h5" size="h5">
                  {item.title}
                </Header>
                <Body>{item.body}</Body>
              </CultureItem>
            ))}
          </CulturesBlock>
        </Col>
      </Title>
    </Wrapper>
  )
}
